import { render } from "./PersonalAccountCochair.vue?vue&type=template&id=5680a7d8&scoped=true&ts=true"
import script from "./PersonalAccountCochair.vue?vue&type=script&lang=ts"
export * from "./PersonalAccountCochair.vue?vue&type=script&lang=ts"

import "./PersonalAccountCochair.vue?vue&type=style&index=0&id=5680a7d8&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5680a7d8"]])

export default __exports__